import { render } from "./Cta.vue?vue&type=template&id=b7a4c178&scoped=true"
import script from "./Cta.vue?vue&type=script&lang=js"
export * from "./Cta.vue?vue&type=script&lang=js"

import "./Cta.vue?vue&type=style&index=0&id=b7a4c178&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7a4c178"]])

export default __exports__